module.exports = __webpack_public_path__ + "img/3-3.93ac624b.png";